import React from 'react';
import { Col, Container, FormLabel, Row } from 'react-bootstrap';
import Radio from '../Radio/Radio';

export type cardWithCheckboxVariant = 'default' | 'white-background';

export type cardData = {
  mailLocation: string;
  address: string;
  city: string;
  id: string;
};

export type CardWithCheckboxProps = React.PropsWithChildren<{
  cardData: cardData;
  selected: boolean;
  variant?: cardWithCheckboxVariant;
}>;

const CardWithCheckbox = ({
  cardData,
  selected,
  variant = 'default',
}: CardWithCheckboxProps) => {
  const { mailLocation, address, city, id } = cardData;

  return (
    <Container
      className={`px-0 relative card-with-checkbox ${
        selected ? 'selected' : ''
      } ${variant}`}
    >
      <FormLabel className={`p-7 w-100`}>
        <Row className={'align-items-center'}>
          <Col className={'col-8'}>
            <h2 className={'mb-0 text-sub fw-normal'}>{mailLocation}</h2>
          </Col>
          <Col className={'text-end col-4'}>
            <Radio
              className={'mb-0 pe-3 ms-auto radio-checkmark'}
              label={' '}
              id={id}
              value={id}
              checked={selected}
            />
          </Col>
        </Row>
        <Row className={'mt-9'}>
          <Col className={'col-12'}>
            <span className={'text-fs-6 fw-light'}>{address}</span>
          </Col>
          <Col className={'col-12 mt-1'}>
            <span className={'text-fs-6 fw-light'}>{city}</span>
          </Col>
        </Row>
      </FormLabel>
    </Container>
  );
};

export default CardWithCheckbox;
